import { getAllInstancesByElementName } from "../../core";
import GenericTracker from "./generic-tracker";
import ValidatedInput from "../form/validated-input/validated-input"

export default class IdentifyTracker extends GenericTracker {
    constructor () {
        super();
    }

    track() {
        const mail: HTMLInputElement = document.querySelector('[type="email"]');
        if (mail && mail.value) {
            const name = mail.name;
            const instanceValidateInput: ValidatedInput = getAllInstancesByElementName("ValidatedInput", name)[0];
            if(instanceValidateInput.isValid()) {
                //this.tracker.identify((<HTMLInputElement>instanceValidateInput.getElement()).value)
            }
        }
    }
}